import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../../api';
import { useFirmContext } from '../../providers/FirmProvider';

export type InvoiceLineItem = {
    description: string;
    quantity: number;
    unitAmount: number;
    total: number;
};

export type InvoicePreview = {
    invoiceDate: string;
    periodStart: string;
    periodEnd: string;
    currency: string;
    subtotal: number;
    tax: {
        amount: number;
        name: string;
        rate: number;
    };
    discount: number;
    total: number;
    lineItems: InvoiceLineItem[];
    coupon?: {
        id: string;
        percentOff?: number;
        amountOff?: number;
        duration: string;
    };
};

type GetUpcomingInvoiceResponse = {
    invoice: InvoicePreview;
};
async function getInvoice(firmId: string, activeEntities?: number, interval?: string): Promise<GetUpcomingInvoiceResponse> {
    const { data } = await api.get(`/firms/${firmId}/subscription/v2/upcoming-invoice`, {
        params: {
            activeEntities,
            interval,
        },
    });
    return data;
}

export function useUpcomingInvoice(activeEntities?: number, interval?: string): UseQueryResult<GetUpcomingInvoiceResponse, unknown> {
    const { id } = useFirmContext();
    return useQuery(['upcoming-invoice', activeEntities, interval], () => getInvoice(id, activeEntities, interval));
}
